export enum ExtractType {
    EXTRACT_WITH_HISTORY = 'EXTRACT_WITH_HISTORY',
    EXTRACT = 'EXTRACT',
    EXTRACT_OU_WITH_HISTORY = 'EXTRACT_OU_WITH_HISTORY',
    EXTRACT_OU = 'EXTRACT_OU'
}
